/**************************************************
 * Nombre:       Nosotros_Personal
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import Tarjeta_Personal from "../../Tarjetas/Tarjeta_Personal";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Personal from "../../Dialogos/Dialogo_Personal";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";

const Nosotros_Personal = () => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Personal})
    const [personal, setPersonal] = useState([])

    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'personal', wheres: w}).then((dox) => {
            setPersonal(dox.data)
        })
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, pb: 10}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography
                        sx={{color: theme.palette.primary.main, fontSize: 32, fontWeight: 800}}>
                        Personal Calificado
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 8, md: 5}} sx={{justifyContent: 'center', mt: 1}}>
                    <Typography
                        sx={{
                            color: '#000',
                            fontSize: 16,
                            fontWeight: 300,
                            textAlign: 'center',
                            lineHeight: 1.2
                        }}>
                        Nuestro equipo está conformado por personal calificado, listo para brindarte atención
                        profesional, segura y confiable en cada experiencia.
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 4 : 0}
                    >

                        {personal.map((it, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Personal click={abrir} item={it}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Nosotros_Personal
